













































import {
  Component, Vue, Prop,
} from 'vue-property-decorator';

@Component
export default class InputPopup extends Vue {
  @Prop({ default: 'Please set \'title\' attribute' }) title!: string;

  @Prop({ default: 'Please set \'prompt\' attibute' }) prompt!: string; // Prompt text string

  @Prop({ default: '' }) saveHelpText!: string; // Help string displayed on mouseover of button

  @Prop({ default: 'Ok' }) saveButtonName!: string; // Text to display on button

  @Prop({ default: '' }) confirmHelpText!: string; // Help string displayed on mouseover of button

  @Prop({ default: 'Ok' }) confirmButtonName!: string; // Text to display on button

  @Prop({ default: '' }) validationError!: string; // Validation error

  enteredText = '';

  /**
   * Forward the input on to any input-name listener.
   */
  saveButtonHdlr(): void {
    console.log(`Got ${this.enteredText}`);
    this.$emit('input-name', this.enteredText);
  }

  /**
   * Disable the save button when:
   *   there is no text in the reference text area,
   *   when the text in textarea is an unmodified library item
   */
  get saveButtonDisabled(): boolean {
    return this.enteredText === '';
  }

  /**
   * Send input-confirmed to any listeners.
   */
  confirmButtonHdlr(): void {
    console.log(`Got ${this.enteredText}`);
    this.$emit('input-confirmed', this.enteredText);
  }

  /**
   * Disable the save button when:
   *   there is no text in the reference text area,
   *   when the text in textarea is an unmodified library item
   */
  get confirmButtonDisabled(): boolean {
    return this.validationError === '';
  }

  /**
   * Cancel the save operation. Notify any listeners
   */
  cancelButtonHdlr(): void {
    this.$emit('input-cancelled');
  }
}
